import {cloneDeep} from 'lodash';
import {createImageObject} from '../utils';
import {
    placeHolder,
    defaultFormConfig,
    defaultFormData,
    openIndustryByHot,
    temParams
} from '@/views/V2/image/batchPicture/utils';

export default {
    namespaced: true,
    state: {
      title: '批量生图',
      displayImg: [],
      displayType: 'preview', // 预览：preview, 生成：generate
      industryList: [],
      toolBarLoading: false,
      placeHolder,
      editorJson: {},
      canSubmit: true,
      submitType: 'byOrder', // 顺序：byOrder, 随机：byCross
      formConfig: cloneDeep(defaultFormConfig),
      formData: cloneDeep(defaultFormData),
      baseFormData: cloneDeep(defaultFormData),
      previewFromData: {},
      previewRenders: [],
      pageLoadingStatus: {
        show: false,
        title: ''
      }
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_MULTIPLE_STATES(state, updates) {
            for (let update of updates) {
                state[update.key] = update.value;
            }
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_PAGE_STATUS(state, data) {
            state.pageLoadingStatus = data;
        },
        UPDATE_FORM_DATA(state, {key, value}) {
            state.formData = {...state.formData, [key]: value};
        }
    },
    actions: {
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        changePageStatus({commit}, data) {
            commit('CHANGE_PAGE_STATUS', data);
        },
        updateFormData({commit}, data) {
            const {key, value} = data;
            commit('UPDATE_FORM_DATA', {
                key,
                value
            });
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        updateMultipleState({commit}, data) {
            commit('UPDATE_MULTIPLE_STATES', data);
        },
        async getTemplateInfo({commit}, {data, model, templateId = null}) {
            const {value} = data;
            // 模版切换后，获取模版配置
            const activeTab = value?.templateGroup?.template?.activeTab;
            const newTemplateId = templateId || value?.templateGroup?.template?.chooseList[0];
            try {
                if (activeTab === 'myTemplate') {
                    const json = JSON.parse(value?.templateGroup?.template?.chooseMyTpl[0].templateData);
                    let obj = {
                        templateData: json
                    };
                    return obj || null;
                } else {
                    const resData = await model.myCreation.getTemplateDetail({
                        templateId: newTemplateId,
                        templateSource: '1'
                    });
                    return JSON.parse(resData.editorJson) || null;
                }
            } catch (err) {
                console.error(err);
                return null;
            }
        },
        changeLoadingStatus({commit}, {targetCount, ratioNum = 1}) {
            commit('UPDATE_MULTIPLE_STATES', [{
                key: 'displayType',
                value: 'generate'
            }, {
                key: 'pageLoadingStatus',
                value: {
                    show: true,
                    title: `预计将为您生成${targetCount}张图${targetCount >= 100 ? '，超出100张的内容无法生成' : ''}`
                }
            }, {
                key: 'toolBarLoading',
                value: true
            }]);
            // loading态，且有骨架屏数量，则生成骨架屏的结果区占位数据
            if (typeof targetCount === 'number') {
                const baseDisplayImg = Array.from({
                    length: targetCount
                }, (_, i) => createImageObject({
                    ratioNum: ratioNum,
                    recordId: i
                }));
                commit('UPDATE_COMMON_STATE', {
                    key: 'displayImg',
                    value: baseDisplayImg
                });
            }
        },
        handleFormSubmit({commit}, {data}) {
            const displayImg = data.map(item => createImageObject({
                ...item
            }));
            commit('UPDATE_MULTIPLE_STATES', [
                // 更新展示区图片
                {
                    key: 'displayImg',
                    value: displayImg
                },
                {
                    key: 'pageLoadingStatus',
                    value: {
                        show: true,
                        title: `已为您成功生成${displayImg.length}张图`,
                        status: 'success'
                    }
                },
                {
                    key: 'toolBarLoading',
                    value: false
                }
            ]);
            setTimeout(() => {
                commit('UPDATE_MULTIPLE_STATES', [
                    {
                        key: 'pageLoadingStatus',
                        value: {
                            show: false,
                            title: ''
                        }
                    }
                ]);
            }, 3000);
        },
        // 页面信息重置
        resetForm({commit, state}) {
            commit('UPDATE_MULTIPLE_STATES', [{
                key: 'formData',
                value: cloneDeep(state.baseFormData)
            }, {
                key: 'submitType',
                value: 'byOrder'
            }]);
        },
        async getRecommendTemplateId({commit, state}, model) {
            try {
                const res = await model.myCreation.getRecommendTemplateList(temParams);
                return res.imageTemplates[0].templateId;
            } catch (error) {
                console.error(error);
            }
        },
        // 获取图片常量数据，行业选项需要用到
        async getImageTplConstants({commit, state}, model) {
            try {
                const resData = await model.imageCreate.getImageTplConstants({productLine: 'QINGDUO'});
                // ToDo，如果行业不是直接使用常量list，而是要有个性化逻辑的话，需要在这里进行重定义，或者直接改成静态配置options
                const allIndustryList = resData?.industry?.map(item => {
                    return {
                        value: `${item.index > 1 ? item.index : ''}`,
                        label: item.label === '全部' ? '全部行业' : item.label
                    };
                });
                const industryList = openIndustryByHot.map(label => {
                    return allIndustryList.find(item => item.label === label);
                }).filter(item => item !== undefined);

                let formConfig = state.formConfig;
                let industryIndex = formConfig.findIndex(item => item.name === 'templateGroup');
                formConfig[industryIndex].params.industryOptions = industryList;

                commit('UPDATE_MULTIPLE_STATES', [
                    {
                        key: 'formConfig',
                        value: formConfig
                    },
                    {
                        key: 'industryList',
                        value: industryList
                    }
                ]);
            }
            catch (err) {
                throw err;
            }
        }
    },
    getters: {
        formExt: state => {
            return {
                industryList: state.industryList
            };
        }
    }
  };
